/**
 * Intelligems A/B — PDP social proof above product title
 *
 * Test A:
 *   document.body.setAttribute('data-ig-pdp-social-proof', 'a');
 *
 * Test B / true:
 *   document.body.setAttribute('data-ig-pdp-social-proof', 'true');
 *
 * Dev preview: ?ig_pdp_social_proof_test=a | ?ig_pdp_social_proof_test=b
 */
(function () {
  'use strict';

  if (window.__igPdpSocialProofBooted) return;
  window.__igPdpSocialProofBooted = true;

  var ATTR = 'data-ig-pdp-social-proof';
  var MARK = 'data-ig-pdp-social-proof-hydrated';
  var VARIANT_MARK = 'data-ig-pdp-social-proof-variant';
  var RATING_SYNC_MARK = 'data-ig-pdp-rating-synced';

  var isApplying = false;
  var debounceTimer = null;
  var looxRetryTimer = null;
  var looxRetryCount = 0;
  var looxObserver = null;

  var CUSTOMER_NAME = 'James';
  var STATIC_REVIEW_COUNT = '115K+';

  var AVATAR_POOL = [
    { gender: 'men', id: 12 },
    { gender: 'men', id: 32 },
    { gender: 'men', id: 45 },
    { gender: 'men', id: 55 },
    { gender: 'men', id: 71 },
    { gender: 'men', id: 76 },
    { gender: 'men', id: 22 },
    { gender: 'men', id: 29 },
    { gender: 'men', id: 36 },
    { gender: 'men', id: 48 },
    { gender: 'men', id: 61 },
    { gender: 'men', id: 83 }
  ];

  function isTruthy(value) {
    var normalized = String(value || '').trim().toLowerCase();
    return normalized === 'true' || normalized === '1' || normalized === 'on' || normalized === 'yes';
  }

  function normalizeVariant(value) {
    var normalized = String(value || '').trim().toLowerCase();

    if (normalized === 'a') return 'a';
    if (normalized === 'b' || isTruthy(normalized)) return 'b';
    return 'off';
  }

  function getDevVariant() {
    try {
      return normalizeVariant(new URLSearchParams(window.location.search).get('ig_pdp_social_proof_test'));
    } catch (e) {
      return 'off';
    }
  }

  function getVariant() {
    var devVariant = getDevVariant();
    if (devVariant !== 'off') return devVariant;
    if (!document.body) return 'off';
    return normalizeVariant(document.body.getAttribute(ATTR));
  }

  function isActive() {
    return getVariant() !== 'off';
  }

  function usesDynamicRating() {
    return getVariant() === 'b';
  }

  function hashString(value) {
    var hash = 0;
    var str = String(value || '');

    for (var i = 0; i < str.length; i += 1) {
      hash = (hash << 5) - hash + str.charCodeAt(i);
      hash |= 0;
    }

    return Math.abs(hash);
  }

  function createRng(seed) {
    var state = seed || 1;

    return function () {
      state = (state * 1664525 + 1013904223) % 4294967296;
      return state / 4294967296;
    };
  }

  function pickUniqueIndices(rng, poolSize, count) {
    var indices = [];
    var attempts = 0;

    while (indices.length < count && attempts < 100) {
      var index = Math.floor(rng() * poolSize);
      if (indices.indexOf(index) === -1) indices.push(index);
      attempts += 1;
    }

    while (indices.length < count) {
      indices.push(indices.length % poolSize);
    }

    return indices;
  }

  function avatarUrl(entry) {
    return 'https://randomuser.me/api/portraits/' + entry.gender + '/' + entry.id + '.jpg';
  }

  function formatCount(value) {
    var digits = String(value || '').replace(/[^\d]/g, '');
    if (!digits) return String(value || '').trim();
    return Number(digits).toLocaleString('en-US');
  }

  function getProductInfoContainer() {
    return document.querySelector('.main-product__info-container');
  }

  function getRatingSources() {
    var scopes = [];
    var infoContainer = getProductInfoContainer();
    var mobileWrapper = document.querySelector('.dev-cf-6');
    var mediaWrapper = document.querySelector('.product__media-wrapper');

    if (infoContainer) scopes.push(infoContainer);
    if (mobileWrapper && scopes.indexOf(mobileWrapper) === -1) scopes.push(mobileWrapper);
    if (mediaWrapper && scopes.indexOf(mediaWrapper) === -1) scopes.push(mediaWrapper);

    var sources = [];

    scopes.forEach(function (scope) {
      Array.prototype.forEach.call(scope.querySelectorAll('[data-ig-pdp-rating-source]'), function (node) {
        if (sources.indexOf(node) === -1) sources.push(node);
      });

      Array.prototype.forEach.call(
        scope.querySelectorAll('.shopify-app-block[id*="loox_reviews_loox_rating"]'),
        function (node) {
          if (sources.indexOf(node) === -1) sources.push(node);
        }
      );
    });

    return sources;
  }

  function getPrimaryRatingSource() {
    var sources = getRatingSources();
    return sources.length ? sources[0] : null;
  }

  function extractLooxData(source) {
    var looxEl = source.querySelector('.loox-rating, [data-raters], [data-rating]');
    if (!looxEl) return null;

    var count = looxEl.getAttribute('data-raters');
    var rating = looxEl.getAttribute('data-rating');

    if (!count) {
      var text = String(looxEl.textContent || source.textContent || '').replace(/\s+/g, ' ').trim();
      var countMatch = text.match(/\(([\d,]+)\)/);
      if (countMatch) count = countMatch[1];
    }

    if (!count) return null;

    return {
      rating: rating || '4.6',
      count: formatCount(count)
    };
  }

  function parseRatingLabel(labelText) {
    var text = String(labelText || '').replace(/\s+/g, ' ').trim();
    var ratingMatch = text.match(/(\d+(?:\.\d+)?)\s*\/\s*5/i);
    var countMatch = text.match(/\(([\d,]+)\)/) ||
      text.match(/([\d,]+(?:\.\d+)?[kK+]?)\s+reviews?/i);

    var rating = ratingMatch ? ratingMatch[1] : '4.6';
    var count = countMatch ? formatCount(countMatch[1]) : STATIC_REVIEW_COUNT;

    return {
      rating: rating,
      count: count,
      display: rating + ' / 5 (' + count + ' reviews)'
    };
  }

  function extractRatingData(source) {
    if (!source) return null;

    var looxData = extractLooxData(source);
    if (looxData) {
      return {
        rating: looxData.rating,
        count: looxData.count,
        display: looxData.rating + ' / 5 (' + looxData.count + ' reviews)'
      };
    }

    var labelEl = source.querySelector('.rating-stars__label');
    if (!labelEl) return null;

    return parseRatingLabel(labelEl.textContent);
  }

  function setRatingSourcesHidden(hidden) {
    getRatingSources().forEach(function (source) {
      var isHidden = source.getAttribute('data-ig-pdp-rating-hidden') === 'true';

      if (hidden && !isHidden) {
        source.setAttribute('data-ig-pdp-rating-hidden', 'true');
        source.setAttribute('aria-hidden', 'true');
      } else if (!hidden && isHidden) {
        source.removeAttribute('data-ig-pdp-rating-hidden');
        source.removeAttribute('aria-hidden');
      }
    });
  }

  function restoreStaticRating(root) {
    var ratingTextEl = root.querySelector('[data-ig-pdp-social-proof-rating-text]');

    setRatingSourcesHidden(false);

    if (ratingTextEl && root.getAttribute(RATING_SYNC_MARK)) {
      ratingTextEl.setAttribute('data-rating', '4.6');
      ratingTextEl.setAttribute('data-review-count', STATIC_REVIEW_COUNT);
      ratingTextEl.textContent = '4.6 / 5 (' + STATIC_REVIEW_COUNT + ' reviews)';
      root.removeAttribute(RATING_SYNC_MARK);
    }
  }

  function syncDynamicRating(root) {
    var source = getPrimaryRatingSource();
    var ratingTextEl = root.querySelector('[data-ig-pdp-social-proof-rating-text]');

    setRatingSourcesHidden(true);

    if (!ratingTextEl || !source) {
      scheduleLooxRetry();
      return false;
    }

    var parsed = extractRatingData(source);
    if (!parsed) {
      scheduleLooxRetry();
      return false;
    }

    stopLooxRetry();

    if (
      root.getAttribute(RATING_SYNC_MARK) === parsed.count &&
      ratingTextEl.getAttribute('data-rating') === String(parsed.rating) &&
      ratingTextEl.textContent === parsed.display
    ) {
      return true;
    }

    ratingTextEl.setAttribute('data-rating', parsed.rating);
    ratingTextEl.setAttribute('data-review-count', parsed.count);
    ratingTextEl.textContent = parsed.display;
    root.setAttribute(RATING_SYNC_MARK, parsed.count);
    return true;
  }

  function hydrateAvatars(root) {
    var handle = root.getAttribute('data-product-handle') || root.getAttribute('data-product-id') || 'default';
    var rng = createRng(hashString(handle));
    var name = CUSTOMER_NAME;
    var avatarIndices = pickUniqueIndices(rng, AVATAR_POOL.length, 3);
    var nameEl = root.querySelector('[data-ig-pdp-social-proof-name]');

    if (nameEl) {
      nameEl.setAttribute('data-name', name);
      nameEl.textContent = name;
    }

    root.querySelectorAll('[data-ig-pdp-social-proof-avatar]').forEach(function (img, index) {
      var entry = AVATAR_POOL[avatarIndices[index] || index];
      var url = avatarUrl(entry);

      img.setAttribute('src', url);
      img.setAttribute('alt', name + ' customer avatar ' + (index + 1));
      img.setAttribute('data-avatar-index', String(avatarIndices[index] || index));
    });

    root.setAttribute('data-customer-name', name);
    root.setAttribute(MARK, 'true');
  }

  function hydrateRoot(root) {
    if (!root) return;

    var variant = getVariant();
    var previousVariant = root.getAttribute(VARIANT_MARK);

    if (!isActive()) {
      if (previousVariant) restoreStaticRating(root);
      root.removeAttribute(MARK);
      root.removeAttribute(VARIANT_MARK);
      root.removeAttribute('data-variant');
      return;
    }

    if (root.getAttribute(MARK) !== 'true' || previousVariant !== variant) {
      hydrateAvatars(root);
    }

    root.setAttribute(VARIANT_MARK, variant);
    root.setAttribute('data-variant', variant);

    if (usesDynamicRating()) {
      syncDynamicRating(root);
    } else if (previousVariant === 'b') {
      restoreStaticRating(root);
    }
  }

  function getReviewsTarget() {
    var selectors = [
      '#looxReviews',
      '#loox-reviews',
      '[id*="loox_reviews_loox_dynamic"]',
      '.shopify-app-block[id*="loox_reviews_loox_dynamic"]',
      '#shopify-block-loox_reviews_loox_dynamic_section'
    ];

    for (var i = 0; i < selectors.length; i += 1) {
      if (document.querySelector(selectors[i])) return selectors[i];
    }

    return '#looxReviews';
  }

  function bindReviewLinks() {
    var target = getReviewsTarget();

    document.querySelectorAll('[data-ig-pdp-social-proof-reviews-link]').forEach(function (link) {
      if (link.getAttribute('data-reviews-target') !== target) {
        link.setAttribute('href', target);
        link.setAttribute('data-reviews-target', target);
      }
    });
  }

  function applyAll() {
    if (isApplying) return;

    isApplying = true;
    try {
      bindReviewLinks();
      document.querySelectorAll('[data-ig-pdp-social-proof-root]').forEach(hydrateRoot);

      if (isActive() && window.innerWidth < 749) {
        window.dispatchEvent(new Event('resize'));
      }
    } finally {
      isApplying = false;
    }
  }

  function scheduleApply() {
    if (debounceTimer) window.clearTimeout(debounceTimer);
    debounceTimer = window.setTimeout(function () {
      debounceTimer = null;
      applyAll();
    }, 150);
  }

  function scheduleLooxRetry() {
    if (!usesDynamicRating() || looxRetryCount >= 8 || looxRetryTimer) return;

    looxRetryTimer = window.setTimeout(function () {
      looxRetryTimer = null;
      looxRetryCount += 1;
      applyAll();
    }, 400);
  }

  function stopLooxRetry() {
    looxRetryCount = 0;
    if (looxRetryTimer) {
      window.clearTimeout(looxRetryTimer);
      looxRetryTimer = null;
    }
  }

  function watchLooxRating() {
    var container = getProductInfoContainer();
    if (!container || looxObserver) return;

    looxObserver = new MutationObserver(function (mutations) {
      if (!usesDynamicRating()) return;

      var shouldSync = mutations.some(function (mutation) {
        if (mutation.type === 'childList') return true;

        var target = mutation.target;
        if (!target || !target.getAttribute) return false;

        return mutation.attributeName === 'data-raters' ||
          mutation.attributeName === 'data-rating';
      });

      if (shouldSync) scheduleApply();
    });

    looxObserver.observe(container, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-raters', 'data-rating']
    });
  }

  function applyDevVariant() {
    var devVariant = getDevVariant();
    if (devVariant === 'off' || !document.body) return;

    if (document.body.getAttribute(ATTR) !== devVariant) {
      document.body.setAttribute(ATTR, devVariant);
    }
  }

  function init() {
    applyDevVariant();
    applyAll();
    watchLooxRating();

    if (!document.body) return;

    new MutationObserver(function () {
      applyDevVariant();
      scheduleApply();
    }).observe(document.body, {
      attributes: true,
      attributeFilter: [ATTR, 'data-gem-variant', 'data-gem-test-active']
    });

    document.addEventListener('gem:variant:changed', scheduleApply);
    document.addEventListener('shopify:section:load', scheduleApply);
  }

  window.IgPdpSocialProof = {
    setVariant: function (variant) {
      if (!document.body) return;
      document.body.setAttribute(ATTR, variant);
      scheduleApply();
    },
    enable: function () {
      this.setVariant('true');
    },
    enableA: function () {
      this.setVariant('a');
    },
    enableB: function () {
      this.setVariant('b');
    },
    disable: function () {
      if (!document.body) return;
      document.body.setAttribute(ATTR, 'false');
      scheduleApply();
    },
    getVariant: getVariant,
    isActive: isActive,
    hydrate: scheduleApply
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
